import { app } from '../../app';
import { Controller } from './sp-user-type.controller';

app.component('spUserType', {
    bindings: {
        userType: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-user-type.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-user-type/sp-user-type.component.js